import analiticaInstance from '@/vendor/analitica.vendor'

/**
 * @typedef {import('@stone-payments/analitica').EventFactory} EventFactory
 * @description This is the event that will be sent to the Amplitude plugin
 * @description import Amplitude from '@amplitude/resume.amplitude'
 * @example Amplitude.events.actions.exportDataClicked()
 * @description
 * @example context: { filters: {}, viewed: {loadView: () => ({})}, actions: {} }
 */

const resumeEvents = analiticaInstance.eventFactory('Resume', {
  view: {
    loadView: filters => ({
      label: 'resume - page viewed',
      metadata: { filters }
    })
  },
  filters: {
    periodChanged: period => ({
      label: 'resume - period filter changed',
      metadata: { period }
    }),
    chargeTypeChanged: type => ({
      label: 'resume - charge type changed',
      metadata: { type }
    }),
    paymentMethodsTypeValueChanged: type => ({
      label: 'resume - payment methods type value changed',
      metadata: { type }
    }),
    brandsTypeValueChanged: type => ({
      label: 'resume - brands type value changed',
      metadata: { type }
    })
  },
  actions: {
    orderClicked: () => ({
      label: 'resume - new order button clicked'
    }),
    helpCenterClicked: ({ open }) => ({
      label: 'resume - help center button clicked',
      metadata: { open }
    }),
    exportDataClicked: filters => ({
      label: 'resume - export data button clicked',
      metadata: { filters }
    }),
    simulatorClicked: ({ open }) => ({
      label: 'resume - sales simulator button clicked',
      metadata: { open }
    }),
    shopClicked: () => ({
      label: 'resume - shop button clicked'
    })
  }
})

export default resumeEvents
